import { useNavigate } from "react-router-dom";
import { useAppContext } from "@/App";
import { LayoutDashboard, Truck, HardHat, ArrowRightLeft, Wrench, Eye } from "lucide-react";

const DASHBOARD_TABS = [
  { role: "planner", path: "/planner", icon: LayoutDashboard, label: "Planner", color: "bg-lime-500 text-slate-950" },
  { role: "driver", path: "/driver", icon: Truck, label: "Driver", color: "bg-red-600 text-white" },
  { role: "machinist", path: "/machinist", icon: HardHat, label: "Machinist", color: "bg-amber-500 text-slate-950" },
  { role: "transport", path: "/transport", icon: ArrowRightLeft, label: "Transport", color: "bg-blue-600 text-white" },
  { role: "service", path: "/service", icon: Wrench, label: "Service", color: "bg-purple-500 text-white" },
  { role: "viewer", path: "/viewer", icon: Eye, label: "Viewer", color: "bg-slate-600 text-white" },
];

export default function DashboardSwitcher({ currentRole }) {
  const { session } = useAppContext();
  const nav = useNavigate();
  const roleConfig = session?.asset_config?.role_config || "full";

  // Determine accessible dashboards based on role_config
  let accessibleRoles;
  if (roleConfig === "solo") {
    accessibleRoles = ["planner", "driver", "machinist", "transport", "service", "viewer"];
  } else if (roleConfig === "planner_driver") {
    accessibleRoles = ["planner", "driver", "transport", "viewer"];
  } else if (roleConfig === "planner_machinist") {
    accessibleRoles = ["planner", "machinist", "service", "viewer"];
  } else {
    return null; // Full crew — no switcher needed
  }

  const tabs = DASHBOARD_TABS.filter(t => accessibleRoles.includes(t.role));
  if (tabs.length <= 1) return null;

  return (
    <div className="flex items-center gap-1 bg-slate-100 p-1 rounded-xl" data-testid="dashboard-switcher">
      {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = tab.role === currentRole;
        return (
          <button key={tab.role} data-testid={`switch-${tab.role}`}
            onClick={() => nav(tab.path)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-wide transition-all ${
              isActive ? `${tab.color} shadow-sm` : "text-slate-400 hover:text-slate-700 hover:bg-white"
            }`}>
            <Icon className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
